"use client";

import { useInksoftCouponAutoApply } from "@/hooks/useInksoftCouponAutoApply";

/**
 * Global leadgen side effects that still need to run site-wide.
 * The first-visit anniversary signup popup was removed; coupon auto-apply
 * stays so any previously stored discount codes can still apply in Inksoft.
 */
export function LeadgenRuntime() {
  // Run coupon auto-apply globally so it can react once session tokens appear.
  useInksoftCouponAutoApply();

  return null;
}
